
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ybexpress",
      function () {
        return require("private-next-pages/ybexpress.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ybexpress"])
      });
    }
  